const DOMAIN_TYPOS: Record<string, string> = {
  'gamil.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com',
  'gmil.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gmaul.com': 'gmail.com',
  'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cmo': 'gmail.com',
  'gmail.ocm': 'gmail.com', 'gnail.com': 'gmail.com', 'gmal.com': 'gmail.com',
  'gimail.com': 'gmail.com', 'gemail.com': 'gmail.com',
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yhoo.com': 'yahoo.com',
  'yahoo.con': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yahoooo.com': 'yahoo.com',
  'hotmal.com': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
  'hotmali.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
  'outlok.com': 'outlook.com', 'outloook.com': 'outlook.com', 'outlook.con': 'outlook.com',
  'outllok.com': 'outlook.com', 'otulook.com': 'outlook.com',
  'iclod.com': 'icloud.com', 'iclould.com': 'icloud.com', 'icloud.con': 'icloud.com',
}

const isValidEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim())

/**
 * Returns a corrected email address if the given email's domain matches a
 * known common typo (e.g. "you@gamil.com" -> "you@gmail.com"), or null if
 * the email is invalid or its domain isn't a recognized typo.
 */
export function getEmailTypoSuggestion(email: string): string | null {
  if (!isValidEmail(email)) return null
  const trimmed = email.trim()
  const [local, domain] = trimmed.split('@')
  const suggestedDomain = domain ? DOMAIN_TYPOS[domain.toLowerCase()] : undefined
  if (!suggestedDomain) return null
  return `${local}@${suggestedDomain}`
}
